import { FilterGroup } from '../Tools/FilterGroup';
import { ShowUnavailableFilter } from './ShowUnavailableFilter';

export class ShowUnavailableNoColFilter extends ShowUnavailableFilter {

    constructor(parentGroup: FilterGroup) {
        super(parentGroup);
        this.name = 'Voir objets non disponibles.';
        this.nbColums = 0;
    }
}